import { render, staticRenderFns } from "./AdsProgramManager.vue?vue&type=template&id=7af0c7d3&scoped=true&"
import script from "./AdsProgramManager.vue?vue&type=script&lang=js&"
export * from "./AdsProgramManager.vue?vue&type=script&lang=js&"
import style0 from "./AdsProgramManager.vue?vue&type=style&index=0&id=7af0c7d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af0c7d3",
  null
  
)

export default component.exports